import _ from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AutoComplete from 'material-ui/AutoComplete';

function getInitialValue() {
    return { _id: '', flag: '' };
}

function FlagsComplianceAutoComplete({ items = [], addToAvoid }) {
    const [value, setValue] = useState(getInitialValue());

    const handleSelectCountry = (country) => {
        addToAvoid(country);
        setValue(getInitialValue);
    };

    return (
        <AutoComplete
            searchText={value.flag}
            hintText="Type anything"
            dataSource={items}
            dataSourceConfig={{ text: 'flag', value: '_id' }}
            onNewRequest={handleSelectCountry}
            onUpdateInput={val => setValue({ _id: '', flag: _.capitalize(val) })}
            floatingLabelText="Search country"
            hintStyle={{ fontSize: '13px' }}
            textFieldStyle={{ fontSize: '13px' }}
            menuStyle={{
                width: '350px',
                maxHeight: '300px',
            }}
            popoverProps={{ 
                canAutoPosition: true,
            }}
        />
    );
}

export default connect(
    (state) => {
        return {
            items: state.flagCompliance.items.map((item) => {
                return _.pick(item, ['_id', 'flag']);
            }),
        };
    },
    dispatch => bindActionCreators(
        {},
        dispatch,
    ),
)(FlagsComplianceAutoComplete);



// WEBPACK FOOTER //
// ./app/components/FlagCompliance/FlagsComplianceAutoComplete.jsx